import { CalendarOutlined, DownOutlined, LaptopOutlined, PieChartOutlined, ToolOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';
import { Link, useNavigate } from "react-router-dom";
import useProfileData from '../../hooks/useProfileData';

export default function OpuNavbar() {
    const navigate = useNavigate();
    const { profileData } = useProfileData();
    const attendance = [
        {
            label: "Mark Attendance",
            key: "Attendance/MarkAttendance",
        },
        {
            label: "Attendance Report",
            key: "Attendance/AttendanceList",
        },
        {
            label: "Request Leave",
            key: "Attendance/RequestLeave",
        },
        {
            label: "Leave History",
            key: "Attendance/LeaveHistory",
        }
    ];
    const reviewFormLink = (profileData.appraisalFormId) ?
        (profileData.appraisalFormId === 1) ? `Appraisal/1?EmpId=${profileData.loginId}` :
            (profileData.appraisalFormId === 2) ? `Appraisal/2?EmpId=${profileData.loginId}` :
                (profileData.appraisalFormId === 3) ? `Appraisal/3?EmpId=${profileData.loginId}` :
                    (profileData.appraisalFormId === 5) ? `Appraisal/5?EmpId=${profileData.loginId}` :
                        'Appraisal/Not-Found' :
        'Appraisal/Not-Found'

    const reviewAndPerformace = [
        {
            label: "My Review Form",
            key: reviewFormLink,
        },
        {
            label: "Manager Audit",
            key: "Appraisal/ManagerAuditEmpList",
        },
        {
            label: "Send Letter",
            key: "Appraisal/SendLetter"
        }
    ];

    const settings = [
        {
            label: "Incentive Master",
            key: 'IncentiveMaster/ExtraIncentive',
        }
    ];

    const Kras = [
        {
            label: "My KRA",
            key: "MyKRAForm",
        },
        {
            label: "Approve KRA",
            key: "ManagerKRAapproval",
        },
    ];

    const onClick = ({ key }) => {
        // message.info(`Click on item ${key}`);
        navigate(`/${key}`, { replace: true });
    };
    return (
        <div className='dropdown-navbar'>
            <Link to="/OrderProcessDefault" style={{
                fontSize: '14px',
                color: 'black',
                fontWeight: 500
            }}>
                <Space>
                    <ToolOutlined />Order Process
                </Space>
            </Link>
            {/* attendance */}
            <Dropdown
                menu={{
                    items: attendance,
                    onClick,
                }}
            >
                <a
                    onClick={(e) => e.preventDefault()}
                    style={{
                        color: "black",
                        fontSize: "13px",
                        fontWeight: 600,
                        marginLeft: "0.75rem",
                    }}
                >
                    <Space>
                        <ToolOutlined />
                        Attendance Details
                        <DownOutlined />
                    </Space>
                </a>
            </Dropdown>

            <Dropdown
                className="mx-3"
                menu={{
                    items: Kras,
                    onClick,
                }}
            >
                <a
                    onClick={(e) => e.preventDefault()}
                    style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
                >
                    <Space>
                        <PieChartOutlined />
                        KRA
                        <DownOutlined />
                    </Space>
                </a>
            </Dropdown>

            <Dropdown
                menu={{
                    items: reviewAndPerformace,
                    onClick,
                }}
            >
                <a
                    onClick={(e) => e.preventDefault()}
                    style={{
                        color: "black",
                        fontSize: "13px",
                        fontWeight: 600,
                        marginLeft: "0.75rem",
                    }}
                >
                    <Space>
                        <ToolOutlined />
                        Review
                        <DownOutlined />
                    </Space>
                </a>
            </Dropdown>

            {/* customer master */}
            <Link to="/CustomerMaster" style={{
                fontSize: '14px',
                color: 'black',
                fontWeight: 500
            }}>
                <Space>
                    <ToolOutlined />Customer Master
                </Space>
            </Link>

            <Link to="/DAR/ActivityStatus" style={{
                fontSize: '14px',
                color: 'black',
                fontWeight: 500
            }}>
                <Space>
                    <ToolOutlined /> DAR Activity Status
                </Space>
            </Link>

            {/* qpi calculator */}
            <Link
                to="/QPI/List"
                style={{
                    color: "black",
                    fontSize: "13px",
                    fontWeight: 600,
                    marginLeft: "0.75rem",
                }}
            >
                <Space>
                    <LaptopOutlined />
                    QPI Calculator
                </Space>
            </Link>

            <Link
                to="/Appraisal/CeoReview" style={{ color: "black", fontSize: '13px', fontWeight: 600 }}
            >
                <Space>
                    <CalendarOutlined />CEO Review
                </Space>
            </Link>

            <Dropdown
                menu={{
                    items: settings,
                    onClick,
                }}
            >
                <a
                    onClick={(e) => e.preventDefault()}
                    style={{
                        color: "black",
                        fontSize: "13px",
                        fontWeight: 600,
                        marginLeft: "0.75rem",
                    }}
                >
                    <Space>
                        <ToolOutlined />
                        Settings
                        <DownOutlined />
                    </Space>
                </a>
            </Dropdown>
        </div>
    )
}